module.exports = __webpack_public_path__ + "r-v3/img/arrow_comment.d97266e9.svg";